import React from 'react';

const SearchSVG = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6176 16.032C13.078 17.2635 11.125 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 11.125 17.2635 13.0781 16.0318 14.6178L19.7071 18.293C20.0976 18.6835 20.0976 19.3167 19.7071 19.7072C19.3165 20.0977 18.6834 20.0977 18.2928 19.7072L14.6176 16.032ZM16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9Z"
        fill="#969FA8"
      />
    </svg>
  )
};

export default SearchSVG;
